import Button from 'components/Button'
import Icon from 'components/Icon'
import ModalDialog from 'components/ModalDialog'
import styles from './styles.module.scss'

interface IDeleteDialogProps {
  isOpen: boolean
  message: string
  toggle: () => void
  onDelete: () => void
  onCancel: () => void
}

const DeleteDialog = (props: IDeleteDialogProps) => {
  const { isOpen, message, toggle, onDelete, onCancel } = props

  return (
    <ModalDialog isOpen={isOpen} toggle={toggle} headless className={styles.deleteDialog}>
      <Icon icon="trash-alt" group="unicon" />
      <p>WARNING: THIS ACTION CANNOT BE UNDONE</p>
      <p>{message}</p>
      <div className={styles.actionBtns}>
        <Button className={styles.deleteButton} onClick={onDelete}>
          Yes, Delete
        </Button>
        <Button outline className={styles.cancelButton} onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </ModalDialog>
  )
}

export default DeleteDialog
